<script>
	import { pageOffset } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';
	import { environment } from '../js/utils/environment';
	import { visibility } from '../js/utils/visibility';

	let _text;
	let inView = false;
	let start;
	let stop;
	export let speedMultiplier;

	/**
	* Returns a bounding rectangle as Object and no DOMRect
	*/
	const getBoundingClientRect = element => {
      const {top, right, bottom, left, width, height, x, y} = element.getBoundingClientRect();
      return {top, right, bottom, left, width, height, x, y}
    };

	let animation = (value) => {

		let currentPageOffset = value;

		// Check whether we are in the visible viewport
		let viewportHeight = environment().innerHeight() * 0.7;
		const childRect = getBoundingClientRect(_text);			// we need an Object since DOMRect properties are readonly
		childRect.width = window.innerWidth;	// keeps us within the window
		childRect.left = 0;						// keeps us within the window

		if (childRect.height > viewportHeight) {
			viewportHeight = childRect.height;
		}

		const parentRect = {
			bottom: viewportHeight + (environment().innerHeight() - viewportHeight) / 2,
			height: viewportHeight,
			left: 0,
			right: environment().innerWidth(),
			top: (environment().innerHeight() - viewportHeight) / 2,
			width: environment().innerWidth()
		};

		const overlap = visibility().getOverlap(parentRect, childRect);

		if (overlap >= 1) {
			if (!inView) {
				start = currentPageOffset;
				stop = start + window.innerHeight - childRect.height;
				inView = true;
			}

			let maxDistanceY = stop - start;
			let maxDistanceX = _text.getBoundingClientRect().width - window.innerWidth;
			let scrollProgress = (stop - currentPageOffset) / maxDistanceY;


			_text.style.marginLeft = `-${maxDistanceX * (1 - scrollProgress)}px`;
		}
		else {
			inView = false;
		}

	};

	let prepareScene = () => {
		if (!_text) {
			requestAnimationFrame(prepareScene);
			return;
		}

		while (_text.offsetHeight > (window.innerHeight / 2) - 100) {
			_text.style.width = `calc(${window.getComputedStyle(_text, null).getPropertyValue("width")} + 10px)`;
		}

		pageOffset.subscribe(animation);
	};

	prepareScene();

</script>

<style>
	.text {
		padding-bottom: 2vh;
		width: 119vw;
		margin-left: 0;
		text-align: justify;
	}
</style>

<div class="text" bind:this={_text}>
	Anja Chavelski &bull; ASPICON GmbH &bull; Bechtle GmbH &amp; Co. KG &bull; Bildungs- &amp; InnovationsPortal Chemnitz &bull; BIP Chemnitz &bull; BPS Bildungsportal Sachsen GmbH &bull; bruno banani underwear GmbH &bull; BurgEins GmbH &bull; Büro für Infrastruktur und Versorgungssysteme &bull; Büro für Städtebau GmbH Chemnitz &bull; C&amp;E Consulting und Engineering GmbH &bull; C3 Chemnitzer Veranstaltungszentren GmbH &bull; CEWUS Chemnitzer Werkstoff- und Oberflächentechnik GmbH &bull; Chemieanlagenbau Chemnitz GmbH &bull; Chemnitzer Werkstoffmechanik GmbH &bull; CiBOARD electronic GmbH &bull; conono GmbH &bull; CREATIVCLICKS &bull; DEKRA Automobil GmbH &bull; Deutsche Bank AG &bull; DIGITAL COLOR SERVICE GmbH &bull; DMK E-Business GmbH &bull; Dreßler &amp; Nöbel GbR Janssen Restaurant &bull; e-dox GmbH &bull; EDC Electronic Design Chemnitz GmbH &bull; eins energie in sachsen GmbH &amp; Co. KG &bull; EMIL LEONHARDT GmbH &amp; Co. KG &bull; envia Mitteldeutsche Energie AG &bull; EOR Mediastudio GbR &bull; Explainora e. V. &bull; F+U Sachsen gGmbH &bull; FASA AG &bull; first moment GmbH &bull; FLEXIVA automation &amp; Robotik GmbH &bull; foneta – Sprache. Kommunikation. Kultur. &bull; Förderverein der Gebrüder-Grimm-Grundschule Chemnitz &bull; FOTOGRAFIE | Daniela Schleich &bull; Fraunhofer-Institut für Elektronische Nanosysteme ENAS &bull; Fraunhofer-Institut für Werkzeugmaschinen und Umformtechnik IWU &bull; Fröbel Medientechnik GmbH &bull; GPP Chemnitz Gesellschaft für Prozeßrechnerprogrammierung mbH &bull; Grundstücks- und Gebäudewirtschafts-Gesellschaft m.b.H. &bull; GUNTER HÜTTNER + Co. GmbH &bull; H&amp;T ProduktionsTechnologie GmbH &bull; Handwerkskammer Chemnitz  &bull; Haus E &bull; herold.connect GmbH &bull; HEUKING KÜHN LÜER WOJTEK Partnerschaft mit beschränkter Berufshaftung von Rechtsanwälten und Steuerberatern &bull; Hirsack + Co. Planungsgesellschaft &bull; HQM Induserv GmbH &bull; HTM Härtetechnik &amp; Metallbearbeitung GmbH &bull; IAV GmbH &bull; ibes AG &bull; IKEA Chemnitz &bull; imk automotive GmbH &bull; IMM electronics GmbH &bull; Industrie- und Handelskammer Chemnitz &bull; inlingua Chemnitz &bull; iproplan® Planungsgesellschaft mbH &bull; Jesus Freaks Chemnitz e. V. &bull; Jörg Salzer Wirtschaftsprüfer / Steuerberater &bull; Juwelier ROLLER e.K. &bull; Katja Billep Planungsteam &bull; KIESELSTEN International GmbH &bull; Kirsten Helmstedt &bull; Klang von Blau Agenturgruppe &bull; KOKI TECHNIK Transmission Systems GmbH &bull; KSG Leiterplatten GmbH &bull; Lagertechnik Steger GmbH &bull; Landesbank Baden-Württemberg &bull; LWL-Sachsenkabel GmbH &bull; mailingwork GmbH &bull; maximo Strickmoden Bruno Barthel GmbH &bull; mediatack GmbH &bull; medienspinnerei &bull; my-Tec GmbH &bull; NILES-SIMMONS-HEGENSCHEIDT GmbH &bull; Oetzis &amp; icloud &bull; Olaf und Lissy Jörg &bull; P+P Assekuranzmakler &bull; PAN Seminare &bull; Patt Fischer Feuring Senger &bull; Pentacor &bull; PETERSEN HARDRAHT PRUGGMAYER Rechtsanwälte Steuerberater &bull; premium technologies
</div>
